import React, { useMemo } from "react";
import { TextInput } from "artisn-ui-react";
import { useFormContext } from "react-hook-form";
import { convertDataToDataSelect } from "@anefi/utils";
import { useFetchBankAccountTypes, useFetchBanks } from "@anefi/services";

import Styles from "./StepEightForm.styles";
import { StepEightFormProps as Props } from "./StepEightForm.types";
import { StepEightFormValues } from "./StepEightForm.types";
import Select from "components/global/Select/Select";
import useI18n from "hooks/useI18n";

const StepEightForm: React.FC<Props> = props => {
  const t = useI18n();
  const { register, formState } = useFormContext<StepEightFormValues>();
  const { data: banks } = useFetchBanks();
  const { data: bankAccountTypesData } = useFetchBankAccountTypes();

  const banksForSelect = useMemo(
    () => convertDataToDataSelect(banks, "institutionCode", "name"),
    [banks]
  );

  const bankAccountTypesForSelect = useMemo(
    () => convertDataToDataSelect(bankAccountTypesData, "code", "name"),
    [bankAccountTypesData]
  );

  const { bankAccountNumber } = formState?.errors ?? {};
  const { bankAccountfinancialEntityCode } = formState?.errors ?? {};
  const { bankAccountTypeCode } = formState?.errors ?? {};

  return (
    <Styles className="StepEightForm">
      <Select
        {...register("bankAccountfinancialEntityCode")}
        className="StepEightForm__select"
        selectData={banksForSelect}
        label={t.stepNineForm.bankEntity}
        placeholder={t.stepNineForm.bankEntity}
        errorMessage={bankAccountfinancialEntityCode?.message}
      />
      <TextInput
        {...register("bankAccountNumber")}
        className="field"
        label={t.bankAccountForm.accountNumber}
        placeholder="0000000000"
        maxLength={50}
        errorMessage={bankAccountNumber?.message}
      />
      <Select
        {...register("bankAccountTypeCode")}
        className="StepEightForm__select"
        selectData={bankAccountTypesForSelect}
        label={t.stepNineForm.bankAccountType}
        placeholder={t.stepNineForm.bankAccountType}
        errorMessage={bankAccountTypeCode?.message}
      />
    </Styles>
  );
};

StepEightForm.defaultProps = {};

export default StepEightForm;
